module.exports = __webpack_public_path__ + "static/media/scratch_serverless.9fb4f821.png";